// extracted by mini-css-extract-plugin
module.exports = {"section":"AIActions_section__c5Urg","button":"AIActions_button__E2X8P"};